import {
    chainWalk, checkInactiveOrDeprecatedAsset,
    convertTableJsonToAsset, getAssetLabelFromMac, deepCopyObject,
    getNodeId,
    isResponseCode5xx,
    logOperationalMetric, setAliasToRequest,
    getAliasFromParent
} from "../../../util/Util";
import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET,
    DEFAULT_VENDOR_ATTRIBUTES,
    LOADING_STRING,
    AUTO_LOADER_ASSET_TYPE, DEPRECATED, getUpdateAssetMessageAlertWithSite,
    ALERT_UPDATE_SUCCESS_ASSET_MESSAGE,
} from "../../../util/Constants";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset,
    updateAssetInPlace
} from "../../../resources/AssetResource";
import {updateConfigurationsInAutoLoaderAssetObject} from "../datamodel/AutoLoaderAssetModelResource";


const metricProcessName = "AUTOLOADER_DEVICE_DETAILS";
export function fetchAutoLoaderDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: AUTO_LOADER_ASSET_TYPE
    }
    getAutoLoaderDeviceDetails(dispatcher, request)
}

export function setAutoLoaderDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, AUTO_LOADER_ASSET_TYPE, ACTIVE);
    addAutoLoaderDeviceDetails(dispatcher, request, showCustomAlert)
}

export function updateAutoLoaderDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    const request = convertTableJsonToAsset(stateValues, AUTO_LOADER_ASSET_TYPE, ACTIVE);
    updateAutoLoaderAsset(dispatcher, request, showCustomAlert);
}

export function deleteAutoLoaderDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAutoLoaderDeviceDetails(dispatcher, request)
}

export async function updateAutoLoaderConfiguration(dispatcher, configurations, mac, showCustomAlert) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const alias = await getAliasFromParent();
    const updatedAsset = updateConfigurationsInAutoLoaderAssetObject(getAssetResult.data.asset, configurations, alias);
    const updateResult = await updateAsset(updatedAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isUpdateSuccess = updateResult.status === 200;
    const isFault = isResponseCode5xx(updateResult.status)
    fetchAutoLoaderDeviceDetails(dispatcher)

    // Log operation
    isUpdateSuccess ? showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE) : showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
    logOperationalMetric(startTime, metricProcessName, "updateAutoLoaderConfiguration", isUpdateSuccess, isFault);
}

export async function updateAutoLoaderDeviceMac(dispatcher, stateValues, mac, showCustomAlert) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        showCustomAlert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", false, false);
    } else {
        deleteAutoLoaderDeviceDetails(dispatcher, mac);
        setAutoLoaderDeviceDetails(dispatcher, stateValues, showCustomAlert);
    }
}

async function addAutoLoaderDeviceDetails(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const isFault = isResponseCode5xx(result.status)
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdateAsset = isResponseCode5xx(responseUpdateAsset.status)
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", false, isFaultInUpdateAsset);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAutoLoaderDeviceDetails", true, false);
        }
        fetchAutoLoaderDeviceDetails(dispatcher);
    });
}

async function updateAutoLoaderAsset(dispatcher, request, showCustomAlert) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAutoLoaderDeviceDetails(dispatcher);
        return;
    }
    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAutoLoaderDeviceDetails", isSuccess, isFault);
    fetchAutoLoaderDeviceDetails(dispatcher);
}


async function getAutoLoaderDeviceDetails(dispatcher, request) {
    const model = {
        autoLoaderDeviceInformation: {},
        macAddressArray: []
    }
    // Fetch static asset details
    await getAutoLoaderDeviceStaticDetails(dispatcher, model, request);
    // TODO:: Fetch asset status details
}

async function getAutoLoaderDeviceStaticDetails(dispatcher, model, request) {
    let pageToken = null;
    // do-while loop until we get a valid pageToken
    do {
        const startTime = Date.now();
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const isSuccess = getAssetsResult.status === 200;
        const isFault = isResponseCode5xx(getAssetsResult.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getAutoLoaderDeviceDetails", isSuccess, isFault);

        if (isSuccess) {
            addAutoLoaderDeviceStaticDetailsToModel(getAssetsResult, model)
            // modifying pageToken to fetch from the latest get assets' result
            pageToken = getAssetsResult.data.pageToken
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    } while (pageToken);
    dispatcher({type: "RECEIVE_DATA", data: model});
}

const addAutoLoaderDeviceStaticDetailsToModel = (result, model) => {
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((deviceDetail) => {
            if (deviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(deviceDetail.assetAttributes.mac)
                const mac = deviceDetail.assetAttributes.mac;
                const id = JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;
                model.autoLoaderDeviceInformation[mac] = {
                    name: deviceDetail.assetAttributes.name,
                    mac: deviceDetail.assetAttributes.mac,
                    ip: deviceDetail.assetAttributes.ip,
                    id: id,
                    port: deviceDetail.assetAttributes.port,
                    vendorAttributes: deviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: deviceDetail.assetAttributes.deviceType,
                    assetType: deviceDetail.assetType,
                    startTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).reason, ""),
                }
            }
        });
    }
    return model;
}

async function setAssetLabelDeprecatedAutoLoaderDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAutoLoaderDeviceDetails", true, false);
            fetchAutoLoaderDeviceDetails(dispatcher);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAutoLoaderDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function updateAutoLoaderMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAutoLoaderMonitoringSchedule(dispatcher, updatedAsset)
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

async function updateAutoLoaderMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request,
        chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAutoLoaderDeviceDetails", isSuccess, isFault);
    fetchAutoLoaderDeviceDetails(dispatcher);
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/network/AutoLoaderDeviceNetworkAPI.js